/* Glowishly — scripts propios */
(function () {
  if (window.__glLoaded) return; window.__glLoaded = true;
  function initReveal() {
    var els = document.querySelectorAll('.gl-reveal:not(.gl-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('gl-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('gl-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initMarquee() {
    document.querySelectorAll('[data-gl-marquee]').forEach(function (t) {
      if (t.dataset.ready) return; t.dataset.ready = '1';
      t.innerHTML = t.innerHTML + t.innerHTML;
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-gl-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-gl-main]');
      g.querySelectorAll('[data-gl-thumb]').forEach(function (b) {
        b.addEventListener('click', function () {
          main.src = b.dataset.src; main.srcset = '';
          g.querySelectorAll('[data-gl-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
        });
      });
    });
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }

  function initProduct() {
    document.querySelectorAll('[data-gl-product]').forEach(function (root) {
      var jsonEl = root.querySelector('[data-gl-variants]');
      var isKit = root.hasAttribute('data-gl-kit');
      if (!jsonEl && !isKit) return;
      var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      var idInput = root.querySelector('input[name=id]');
      var priceEl = root.querySelector('[data-gl-price]');
      var compareEl = root.querySelector('[data-gl-compare]');
      var saveEl = root.querySelector('[data-gl-save]');
      var btn = root.querySelector('[data-gl-add]');
      var fmt = root.dataset.money;
      var addText = root.dataset.addText, soldText = root.dataset.soldText;
      var radios = root.querySelectorAll('input[type=radio][name^=gl-opt-]');

      function current() {
        var chosen = [];
        var names = []; radios.forEach(function (r) { if (names.indexOf(r.name) < 0) names.push(r.name); });
        names.sort().forEach(function (n) { var c = root.querySelector('input[name="' + n + '"]:checked'); chosen.push(c ? c.value : null); });
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
      }
      function update() {
        var v = current();
        if (!v) { btn.disabled = true; btn.textContent = soldText; return; }
        idInput.value = v.id;
        priceEl.textContent = v.price_fmt;
        if (v.compare && v.compare > v.price) {
          compareEl.textContent = v.compare_fmt; compareEl.hidden = false;
          if (saveEl) { saveEl.textContent = '-' + Math.round((1 - v.price / v.compare) * 100) + '%'; saveEl.hidden = false; }
        } else { compareEl.hidden = true; if (saveEl) saveEl.hidden = true; }
        btn.disabled = !v.available;
        btn.querySelector('span').textContent = v.available ? addText : soldText;
        if (v.image && root.querySelector('[data-gl-main]')) {
          var main = root.querySelector('[data-gl-main]'); main.src = v.image; main.srcset = '';
        }
        var url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
      radios.forEach(function (r) { r.addEventListener('change', update); });

      if (isKit) {
        var bagRadios = root.querySelectorAll('input[name=gl-bag]');
        var chosenBag = function () { return root.querySelector('input[name=gl-bag]:checked'); };
        var updKit = function () {
          var r = chosenBag(); if (!r) return;
          priceEl.textContent = r.dataset.totalFmt;
          var cmp = +r.dataset.compare || 0, tot = +r.dataset.total || 0;
          if (cmp > tot) { compareEl.textContent = r.dataset.compareFmt; compareEl.hidden = false; if (saveEl) { saveEl.textContent = '-' + Math.round((1 - tot / cmp) * 100) + '%'; saveEl.hidden = false; } } else { compareEl.hidden = true; if (saveEl) saveEl.hidden = true; }
          var ex = root.querySelector('[data-gl-extra-price]'); if (ex) ex.textContent = '+' + r.dataset.bagFmt;
          btn.disabled = r.dataset.avail !== 'true';
          btn.querySelector('span').textContent = r.dataset.avail === 'true' ? addText : soldText;
        };
        bagRadios.forEach(function (r) { r.addEventListener('change', updKit); });
        var form = root.querySelector('form');
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var r = chosenBag(); if (!r) return;
          var q = parseInt(form.querySelector('[name=quantity]').value, 10) || 1;
          btn.disabled = true;
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +root.dataset.machine, quantity: q }, { id: +r.value, quantity: q * (root.querySelector('[name=gl-extra]') && root.querySelector('[name=gl-extra]').checked ? 2 : 1) }] }) })
            .then(function (res) { if (!res.ok) throw new Error('add'); window.location.href = '/cart'; })
            .catch(function () { btn.disabled = false; alert('Sorry, we could not add the kit to your cart. Please try again.'); });
        });
      }

      var qty = root.querySelector('[data-gl-qty]');
      if (qty) {
        var input = qty.querySelector('input');
        qty.querySelector('[data-minus]').addEventListener('click', function () { input.value = Math.max(1, (+input.value || 1) - 1); });
        qty.querySelector('[data-plus]').addEventListener('click', function () { input.value = (+input.value || 1) + 1; });
      }

      var bar = document.querySelector('[data-gl-sticky]');
      if (bar && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { bar.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(btn);
        var sb = bar.querySelector('button');
        if (sb) sb.addEventListener('click', function () { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      }
    });
  }

  function initBags() {
    document.querySelectorAll('[data-gl-bags]').forEach(function (root) {
      var radios = root.querySelectorAll('input[name=id]');
      var qty = root.querySelector('[data-gl-qty]'); if (qty) { var qi = qty.querySelector('input'); qty.querySelector('[data-minus]').addEventListener('click', function () { qi.value = Math.max(1, (+qi.value || 1) - 1); }); qty.querySelector('[data-plus]').addEventListener('click', function () { qi.value = (+qi.value || 1) + 1; }); }
      var p = root.querySelector('[data-gl-bag-price]'), c = root.querySelector('[data-gl-bag-compare]'), btn = root.querySelector('[data-gl-bag-add]');
      radios.forEach(function (r) { r.addEventListener('change', function () {
        p.textContent = r.dataset.priceFmt;
        if (r.dataset.compareFmt) { c.textContent = r.dataset.compareFmt; c.hidden = false; } else { c.hidden = true; }
        if (btn) btn.disabled = r.dataset.avail !== 'true';
      }); });
    });
  }

  function init() { initBags(); initMarquee(); initReveal(); initGallery(); initProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
